import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { Field, FieldArray, reduxForm, reset, SubmissionError } from 'redux-form';

import UploadField from 'components/fields/UploadField';
import FormError from 'components/common/FormError';

import {
  createPatientDocument,
  addPatientDocumentResource,
} from 'redux/modules/patientsDocuments';
import { addNotification } from 'redux/modules/notifications';
import { accountLoginFail } from 'redux/modules/account';

import formatSinglePlural from 'utils/formatSinglePlural';
import DocumentsCreateFieldArray from './DocumentsCreateFieldArray';

const styles = () => ({
  grid: {
    marginTop: 10,
    '&:first-child': {
      marginTop: 0,
    },
  },
});

function onSubmit(values, dispatch, props) {
  return Promise.all(values.Documents.map(item =>
    new Promise((resolve, reject) => {
      dispatch(createPatientDocument({
        values: {
          'Record Number': props['Record Number'],
          ...item,
        },
        resolve,
        reject,
      }));
    }).then(res => new Promise((resolve, reject) => {
      if (item['Document Category'] && item['Document Category'].length > 0) {
        dispatch(addPatientDocumentResource({
          values: {
            ID: res.ID,
            'Document Category ID': item['Document Category'].map(documentCategoriesItem =>
              documentCategoriesItem.value),
          },
          resolve,
          reject,
        }));
      } else {
        resolve(res);
      }
    })))).then((res) => {
    dispatch(addNotification({
      message: `${res.map(item => item['File Name']).join(', ')} ${formatSinglePlural({
        quantity: res.length,
        single: 'was',
        plural: 'were',
      })} saved to chart Documents`,
      variant: 'success',
    }));
    dispatch(reset(props.form));
    return res;
  },
  (err) => {
    if (err.error) {
      throw new SubmissionError({ _error: err.error });
    }
    throw new SubmissionError(err);
  });
}

function onChange(values, dispatch, props) {
  if (values.Document && values.Document.name) {
    props.array.push('Documents', {
      Document: values.Document,
    });
    props.clearFields(false, false, 'Document');
  }
}

const DocumentsForm = ({
  array,
  handleSubmit,
  submitting,
  error,
  className,
  actions,
  classes,
}) => (
  <form
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
    className={className}
  >
    {error &&
      <Grid
        className={classes.grid}
        container
        spacing={24}
      >
        <Grid
          item
          xs={12}
        >
          <FormError>
            {error}
          </FormError>
        </Grid>
      </Grid>
    }
    <FieldArray
      name="Documents"
      component={DocumentsCreateFieldArray}
      submitting={submitting}
      actions={actions}
      array={array}
    />
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Field
          id="Document"
          name="Document"
          component={UploadField}
          placeholder="File Name"
          fullWidth
          loading={submitting}
        />
      </Grid>
    </Grid>
  </form>
);

DocumentsForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  className: PropTypes.string,
  submitting: PropTypes.bool.isRequired,
  error: PropTypes.string,
  array: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  actions: PropTypes.shape({
    accountLoginFail: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
  }).isRequired,
};

DocumentsForm.defaultProps = {
  className: '',
  error: null,
  onDelete: () => {},
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ accountLoginFail }, dispatch),
});

export default connect(null, mapDispatchToProps)(reduxForm({
  form: 'patientDocumentsCreate',
  onSubmit,
  onChange,
  initialValues: {
    Document: {
      name: null,
    },
  },
})(withStyles(styles)(DocumentsForm)));



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/Documents/DocumentsCreateForm.js